import React from "react";
import { motion } from "framer-motion";
import { slideLeft } from "../../animations/variants";
import { CheckCircle, BookOpen, Briefcase, Workflow } from "lucide-react";
import { trainingCTA, trainingListData } from "i18n/training";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  trainingBusinessCTA,
  trainingListBusinessData,
} from "i18n/trainingbusiness";

const ListTrainingBusiness = () => {
  const lang = useSelector((state) => state.language.lang);
  const trainings = trainingListBusinessData[lang];
  const navigate = useNavigate();
  const tCTA = trainingBusinessCTA[lang];

  const iconMap = {
    GraduationCap: BookOpen, // About program → learning
    Users: Briefcase, // Benefits → business
    Brain: Workflow, // How it works → process
  };
  return (
    <section className="py-0 md:py-10">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        {trainings.map((service, index) => {
          const Icon = iconMap[service.icon];

          return (
            <motion.div
              key={service.id}
              variants={slideLeft}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className={`
              border border-redlight my-4
              p-6 md:p-12
              shadow-sm
              relative bg-gray-100

              ${index === 0 ? "md:max-w-[900px] md:mr-20" : ""}
              ${index === 1 ? "md:max-w-[900px] md:ml-24 md:-mt-10" : ""}
              ${index === 2 ? "md:max-w-[900px] md:mr-20 md:-mt-10" : ""}
            `}
            >
              <h3 className="flex items-center gap-3 text-2xl md:text-3xl font-normal mb-6 text-reddark font-[Crimson] animate-neonFlicker">
                {Icon && <Icon className="w-7 h-7 text-reddark shrink-0" />}
                {service.title}
              </h3>
              <p className="text-gray-700 text-base md:text-lg mb-4">
                {service.description}
              </p>

              <ul className="space-y-3 text-gray-700 text-base md:text-lg">
                {service.list.map((item, i) => {
                  const hasColon = item.includes(":");

                  if (!hasColon) {
                    // 👉 Normal paragraph line (no bold)
                    return (
                      <li key={i} className="flex items-start gap-3">
                        <CheckCircle className="w-5 h-5 text-reddark mt-1 shrink-0" />
                        <span>{item}</span>
                      </li>
                    );
                  }

                  // 👉 Bold title before ":"
                  const [title, ...rest] = item.split(":");
                  const description = rest.join(":");

                  return (
                    <li key={i} className="flex items-start gap-3">
                      <CheckCircle className="w-5 h-5 text-reddark mt-1 shrink-0" />
                      <span>
                        <span className="font-semibold">{title}:</span>{" "}
                        {description.trim()}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </motion.div>
          );
        })}
      </div>
      {/* <div className="mt-16 text-center mb-24 px-6">
        <p className="text-lg md:text-xl text-gray-800 mb-6 font-medium">
          {tCTA.text}
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center ">
          <button
            onClick={() => navigate("/contact")}
            className="px-8 py-3 border border-reddark text-white bg-reddark rounded-lg max-w-[200px] mx-auto
                         uppercase tracking-wide text-sm
                         hover:bg-white hover:text-reddark hover:font-semibold transition-all duration-300"
          >
            {tCTA.button1}
          </button>
        </div>
      </div> */}
    </section>
  );
};

export default ListTrainingBusiness;
